import i18n, { type BackendModule, type CallbackError, ResourceKey } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { setDefaultOptions } from 'date-fns';

import { getLocaleForDateFns, getStorageTimeInMinutes } from '#helper/get-locale-for-date-fns';
import { getMainDomain } from '#helper/get-main-domain';
import { ELanguage, supportedLanguages } from '#core/const/locales';

const onSetDefaultOptions = () => {
    setDefaultOptions({
        locale: getLocaleForDateFns()
    });
};

i18n.on('initialized', onSetDefaultOptions);
i18n.on('languageChanged', onSetDefaultOptions);

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .use({
        type: 'backend',
        read(language, namespace, callback) {
            import(`./${language}/${namespace}.json`)
                .then((resources: { default: ResourceKey }) => {
                    callback(null, resources.default);
                })
                .catch((error: CallbackError) => {
                    callback(error, null);
                });
        }
    } as BackendModule)
    .init({
        debug        : import.meta.env.DEV,
        lowerCaseLng : true,
        fallbackLng  : ELanguage.RU,
        returnNull   : false,
        supportedLngs: supportedLanguages,
        ns           : 'translation',
        interpolation: {
            escapeValue: false
        },
        detection: {
            order                  : ['cookie', 'localStorage', 'navigator'],
            caches                 : ['cookie', 'localStorage'],
            convertDetectedLanguage: (lng) => lng.slice(0, 2),
            lookupCookie           : 'external-locale',
            cookieDomain           : getMainDomain(window.location.hostname),
            cookieMinutes          : getStorageTimeInMinutes()
        }
    })
    .catch(console.error);

export default i18n;
export const { t } = i18n;
